<div id="course-enroll-overlay" [class.show]="course" [class.hidden]="!course">
  <div id="course-enroll-container">
    <h1>{{ course?.name }}</h1>

    <div class="students-grid">
      <div class="students-header">
        <div>Vorname</div>
        <div>Nachname</div>
        <div>Geburtsdatum</div>
        <div>Kursbeitritt</div>
      </div>

      @for (p of students; track p.sid) {
        <div class="student-row">
          <div>{{ p.firstname }}</div>
          <div>{{ p.lastname }}</div>
          <div>
            @if (p.birthday) {
              {{ p.birthday | date:'dd.MM.yyyy' }}
            } @else {
              -
            }
          </div>
          <div>
            @if (p.begin) {
              {{ p.begin | date:'dd.MM.yyyy' }}
            } @else {
              -
            }
          </div>
        </div>
      }
    </div>

    <div class="center">
      <button class="button-close" (click)="close()">Close</button>
    </div>
  </div>
</div>
